import { Plan } from "./plan";
export class PlanWrapper {
    plan: Plan = new Plan();
    items: any;
}